// src/components/common/PixelTracker.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PixelTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);

  return null; // renders nothing
};

export default PixelTracker;
